import { Box, Button, Container, TextField, Autocomplete, Switch, Typography } from "@mui/material";
import { CustomNumberInput, Modal } from '../../../components';
import { useEffect, useState } from "react";

const AddStock = ({ index, stores, quantity, store, errors, prices, onChange, s, defaultPrices = null }) => {
  const op = { name: 'sa' }
  return (
    <Box display='flex' flexDirection='row' gap={2} marginY={5}>
      <Box display='flex' flexDirection='column' gap={2} justifyContent='center'>
        <CustomNumberInput
          id={`stock_new[${index}].quantity`}
          label='Venta'
          minimo={0}
          maximo={200}
          error={errors?.stock_new?.quantity}
          helperText={errors?.stock_new?.quantity}
          value={quantity}
          onChange={(event, newValue) => {
            event.preventDefault();
            //setFieldValue('quantity', newValue);
            onChange(`stock_new[${index}].quantity`, newValue);
          }}
          incrementsButtons
        />
        <Autocomplete
          options={stores}
          getOptionLabel={option => option.name}
          clearOnEscape
          //sx={{ marginY: 2 }}
          fullWidth
          onChange={(event, newValue) => {
            //setFieldValue('store_id', newValue?._id || null);
            onChange(`stock_new[${index}].store_id`, newValue?._id);
          }}
          // value={stores?.find(s => s._id === store)?.name}
          //defaultValue={op.name}
          //value={s}
          renderInput={(params) => (
            <TextField
              {...params}
              id={`stock_new[${index}].store_id`}
              label="Tienda"
              type="text"
              variant="standard"
              error={errors?.stock_new?.store_id}
              helperText={errors?.stock_new?.store_id}
              value={store}
            />
          )}
        />

      </Box>
      <Box display='flex' flexDirection='column' gap={2} justifyContent='center'>
        <CustomNumberInput
          symbol
          //labelText='Lista '
          value={prices?.list_price}
          //onChange={handleChange}
          onChange={(event, newValue) => {
            event.preventDefault();
            onChange(`stock_new[${index}].prices_new.list_price`, newValue);
          }}
        />
        <CustomNumberInput
          symbol
          //labelText='Venta '
          value={prices?.sale_price}
          //onChange={handleChange}
          onChange={(event, newValue) => {
            event.preventDefault();
            onChange(`stock_new[${index}].prices_new.sale_price`, newValue);
          }}
        />
      </Box>
    </Box>
  )
}

export default AddStock;